import { Response } from 'components/types/Api';
import { LinkedInLoginResponse, LinkedInUser } from 'components/types';
import { getCall } from './baseCall';
import { LinkedInRedirectType } from '../const';

const linkedInEndpoint = 'api/LinkedIn'

export const getLinkedInAuthUrl =
    async (redirectType: LinkedInRedirectType ) => await getCall<Response<string>>(`${linkedInEndpoint}/GetLinkedInAuthUrl?redirectType=${redirectType}`);

export const getLinkedInUserInfo =
    async (code: string) => await getCall<Response<LinkedInUser>>(`${linkedInEndpoint}/GetLinkedInUserInfo?code=${code}`);

export const getLinkedInLogin =
    async (code: string) => await getCall<LinkedInLoginResponse>(`${linkedInEndpoint}/Login?code=${code}`);
